import React from "react";
import { Control } from "react-hook-form";

import { ValidationError } from "@/lib/hook/useValidation";

import ControlledInputWithRaisingLabel from "@/components/FormElements/ControlledInputWithRaisingLabel";

import {
  ConfigParamValueWithModifiers,
  ImmigramFormElementConfigBase,
  ImmigramFormElementOnChange,
  ImmigramFormElementType,
  useModifiedConfigParamValue,
} from "./common";

export interface ImmigramFormElementConfigText
  extends ImmigramFormElementConfigBase {
  type: ImmigramFormElementType.Text;
  name: string;
  title: ConfigParamValueWithModifiers;
}

interface ImmigramFormTextProps {
  elementConfig: ImmigramFormElementConfigText;
  control: Control;
  onChange: ImmigramFormElementOnChange;
  disabled: boolean;
  validationErrors?: ValidationError | null;
}

function ImmigramFormText({
  elementConfig,
  control,
  onChange,
  disabled,
  validationErrors,
}: ImmigramFormTextProps) {
  const title = useModifiedConfigParamValue(elementConfig.title);

  return (
    <ControlledInputWithRaisingLabel
      control={control}
      label={title}
      fieldName={elementConfig.name}
      onChange={onChange}
      disabled={disabled}
      error={validationErrors?.message}
    />
  );
}

export { ImmigramFormText };
